import { CellPlugin } from '@react-page/editor';
import RankinSearch, {
    NAME_LABEL, NAME_PLACEHOLDER, CASE_NUMBER_LABEL, CASE_NUMBER_PLACEHOLDER, DATE_OF_BIRTH_LABEL, SEARCH_HELP_TEXT,
    SEARCH_LABEL, RESET_LABEL, MARGIN, PADDING, RESET_BUTTON_BACKGROUND_COLOR, RESET_BUTTON_FONT_COLOR, RESET_BUTTON_FONT_SIZE,
    RESET_BUTTON_FONT_STYLE, RESET_BUTTON_FONT_WEIGHT, RESET_BUTTON_BORDER_COLOR, SUBMIT_BUTTON_BACKGROUND_COLOR,
    SUBMIT_BUTTON_FONT_COLOR, SUBMIT_BUTTON_FONT_SIZE, SUBMIT_BUTTON_FONT_STYLE, SUBMIT_BUTTON_FONT_WEIGHT, NAME_WILDCARD, CASE_NUMBER_WILDCARD
} from './components/RankinSearch';

type Data = {
    name: string,
    namePlaceholder: string,
    caseNumber: string,
    caseNumberPlaceholder: string,
    dateOfBirth: string,
    searchHelpText: string,
    search: string,
    reset: string,
    margin: string,
    padding: string,
    resetButtonBackgroundColor: string,
    resetButtonFontColor: string,
    resetButtonFontSize: string,
    resetButtonFontStyle: string,
    resetButtonFontWeight: string,
    resetButtonBorderColor: string,
    submitButtonBackgroundColor: string,
    submitButtonFontColor: string,
    submitButtonFontSize: string,
    submitButtonFontStyle: string,
    submitButtonFontWeight: string,
    nameWildcard: boolean,
    caseNumberWildcard: boolean,
}

const RankinSearchPlugin: CellPlugin<Data> = {
    Renderer: ({ data }) => (
        <RankinSearch
            nameLabel={data.name}
            namePlaceholder={data.namePlaceholder}
            caseNumberLabel={data.caseNumber}
            caseNumberPlaceholder={data.caseNumberPlaceholder}
            dateOfBirthLabel={data.dateOfBirth}
            searchHelpText={data.searchHelpText}
            searchLabel={data.search}
            resetLabel={data.reset}
            margin={data.margin}
            padding={data.padding}
            resetButtonBackgroundColor={data.resetButtonBackgroundColor}
            resetButtonFontColor={data.resetButtonFontColor}
            resetButtonFontSize={data.resetButtonFontSize}
            resetButtonFontStyle={data.resetButtonFontStyle}
            resetButtonFontWeight={data.resetButtonFontWeight}
            resetButtonBorderColor={data.resetButtonBorderColor}
            submitButtonBackgroundColor={data.submitButtonBackgroundColor}
            submitButtonFontColor={data.submitButtonFontColor}
            submitButtonFontSize={data.submitButtonFontSize}
            submitButtonFontStyle={data.submitButtonFontStyle}
            submitButtonFontWeight={data.submitButtonFontWeight}
            nameWildcard={data.nameWildcard}
            caseNumberWildcard={data.caseNumberWildcard}
        />
    ),
    id: 'rankinSearchPlugin',
    title: 'Rankin Search',
    description: 'Search Rankin County citations by Name, Case Number, and/or Date of Birth',
    version: 1,
    controls: [
        {
            title: 'Search Options',
            controls: {
                type: 'autoform',
                schema: {
                    properties: {
                        nameWildcard: {
                            type: 'boolean',
                            title: 'Name - partial match (LIKE) instead of exact',
                            default: NAME_WILDCARD,
                        },
                        caseNumberWildcard: {
                            type: 'boolean',
                            title: 'Case Number - partial match (LIKE) instead of exact',
                            default: CASE_NUMBER_WILDCARD,
                        },
                    },
                    required: [],
                },
            },
        },
        {
            title: 'Labels',
            controls: {
                type: 'autoform',
                schema: {
                    properties: {
                        name: {
                            type: 'string',
                            default: NAME_LABEL,
                        },
                        namePlaceholder: {
                            type: 'string',
                            default: NAME_PLACEHOLDER,
                        },
                        caseNumber: {
                            type: 'string',
                            default: CASE_NUMBER_LABEL,
                        },
                        caseNumberPlaceholder: {
                            type: 'string',
                            default: CASE_NUMBER_PLACEHOLDER,
                        },
                        dateOfBirth: {
                            type: 'string',
                            default: DATE_OF_BIRTH_LABEL,
                        },
                        searchHelpText: {
                            type: 'string',
                            default: SEARCH_HELP_TEXT,
                        },
                        search: {
                            type: 'string',
                            default: SEARCH_LABEL,
                        },
                        reset: {
                            type: 'string',
                            default: RESET_LABEL,
                        },
                    },
                    required: [],
                },
            },
        },
        {
            title: 'Styles',
            controls: {
                type: 'autoform',
                schema: {
                    properties: {
                        margin: {
                            type: 'string',
                            default: MARGIN,
                        },
                        padding: {
                            type: 'string',
                            default: PADDING,
                        },
                        resetButtonBackgroundColor: {
                            type: 'string',
                            default: RESET_BUTTON_BACKGROUND_COLOR,
                        },
                        resetButtonFontColor: {
                            type: 'string',
                            default: RESET_BUTTON_FONT_COLOR,
                        },
                        resetButtonFontSize: {
                            type: 'string',
                            default: RESET_BUTTON_FONT_SIZE,
                        },
                        resetButtonFontStyle: {
                            type: 'string',
                            default: RESET_BUTTON_FONT_STYLE,
                        },
                        resetButtonFontWeight: {
                            type: 'string',
                            default: RESET_BUTTON_FONT_WEIGHT,
                        },
                        resetButtonBorderColor: {
                            type: 'string',
                            default: RESET_BUTTON_BORDER_COLOR,
                        },
                        submitButtonBackgroundColor: {
                            type: 'string',
                            default: SUBMIT_BUTTON_BACKGROUND_COLOR,
                        },
                        submitButtonFontColor: {
                            type: 'string',
                            default: SUBMIT_BUTTON_FONT_COLOR,
                        },
                        submitButtonFontSize: {
                            type: 'string',
                            default: SUBMIT_BUTTON_FONT_SIZE,
                        },
                        submitButtonFontStyle: {
                            type: 'string',
                            default: SUBMIT_BUTTON_FONT_STYLE,
                        },
                        submitButtonFontWeight: {
                            type: 'string',
                            default: SUBMIT_BUTTON_FONT_WEIGHT,
                        },
                    },
                    required: [],
                },
            },
        },
    ],
};

export default RankinSearchPlugin;
